import * as React from 'react';
import { ROOT_ELEMENT_ID, ROOT_SCROLL_CONTAINER_ELEMENT_ID } from '@src/utils/constants';

const DEFAULT_CONTAINERS = [`#${ROOT_ELEMENT_ID}`, `#${ROOT_SCROLL_CONTAINER_ELEMENT_ID}`];

// Add scroll event listener to the specified containers,
// this is used to prevent the popup layer appearing on the wrong place.
export function usePopupOnScroll(
  callback: () => void,
  containers: Array<string | Element | undefined | null> = DEFAULT_CONTAINERS,
) {
  React.useEffect(() => {
    const scrollContainer = Array.from(new Set([...containers, ...DEFAULT_CONTAINERS]))
      .map((item) => {
        if (typeof item === 'string') {
          return document.querySelector(item);
        }

        return item;
      })
      .filter((item) => typeof item?.addEventListener === 'function') as Element[];

    scrollContainer.forEach((it) => it.addEventListener('scroll', callback));

    return () => {
      scrollContainer.forEach((it) => it.removeEventListener('scroll', callback));
    };
  }, [callback, containers]);
}
